import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = { class: "list-disc marker:text-zinc-500" }
const _hoisted_3 = { class: "block md:hidden pb-8" }

import { 
		Auth
	} from '@/api/Auth'

	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// Router
	import {
		useRouter
	} from 'vue-router'

	// Store
	import { 
		store as _jobStore
	} from '@/store/job'
	import {
		localesStore as _localesStore
	} from '@/store/locales'

	// Vue
	import {
		computed,
		ref
	} from 'vue'

	
	const __default__ = { name: 'AdditionalInfo' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: [
		'navigateBack'
	],
  setup(__props, { expose: __expose, emit: __emit }) {


	// Auth
	const {t} = useI18n()
	const jobStore = _jobStore()
	const localesStore = _localesStore()
	const router = useRouter()

	const notes = computed(() => {
		if(localesStore.locales.selected === 'ja') return jobStore.job.jobDetails.notesKanji
		else if(localesStore.locales.selected === 'kana') return jobStore.job.jobDetails.notesKana
		return jobStore.job.jobDetails.notesEnglish
	})

	const groomEmail = ref<string | null>(null)
	const brideEmail = ref<string | null>(null)
	const emailError = ref<string>('')
	const scriptError = ref<string>('')
	const loading = ref<boolean>(false)
	const submissionConfirmation = ref(false)

	async function navigateNext() {
		emailError.value = ''
		scriptError.value = ''

		// Verify either the bride/groom email has been entered
		if((!groomEmail.value || !groomEmail.value?.length) && (!brideEmail.value || !brideEmail.value?.length)) {
			emailError.value = t('sidebar.emailError')
			return
		}

		loading.value = true

		try {
			const jobId = jobStore.job?.jobID
			const scenesArray = jobStore.job?.jobDetails?.scenes
			const scenes = scenesArray?.map(scene => { 
				return { 
					sceneId: scene['job__JOBS_SCENES__jobID::_kp_jobs_scenes_id'], 
					songId: scene['job__JOBS_SCENES__jobID::zctSongID'],
					customSongName: scene.customSong?.songName ?? '',
					customSongArtist: scene.customSong?.mainArtist ?? '',
					customSongAlbum: scene.customSong?.albumName ?? '',
					customSongTrack: scene.customSong?.track ?? '',
				}
			})
			const res = await Auth.submitSongs(jobId, scenes, brideEmail.value, groomEmail.value, notes.value)
			const scriptResult = JSON.parse(res?.response?.scriptResult ?? '{}')

			if(scriptResult.errorCode != 0 && !res.messages[0].code.includes('Operation timed out')) {
				const error = scriptResult.errorMessage
				throw error
			}

			router.push({name: "SongSubmit"})
		}
		catch(e) {
			console.log(e)
			scriptError.value = e
		}
		finally {
			loading.value = false
		}
		
	}

	const emit = __emit

	__expose({
		loading,
		navigateNext,
		submissionConfirmation
	})

  
return (_ctx: any,_cache: any) => {
  const _component_v_heading = _resolveComponent("v-heading")!
  const _component_v_sub_heading = _resolveComponent("v-sub-heading")!
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_checkbox_field = _resolveComponent("v-checkbox-field")!
  const _component_v_error_message = _resolveComponent("v-error-message")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_heading, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('sidebar.additionalInfo')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_sub_heading, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('sidebar.cutoffDateMessageStart')) + " " + _toDisplayString(_unref(jobStore).job.numDaysUpdateSong) + " " + _toDisplayString(_unref(t)('sidebar.cutoffDateMessageEnd')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_sub_heading, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('sidebar.emailMessage')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_tw_input, {
      onInput: _cache[0] || (_cache[0] = () => emailError.value = ''),
      modelValue: groomEmail.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((groomEmail).value = $event)),
      "is-valid": !emailError.value?.length,
      label: _unref(t)('sidebar.groomEmail'),
      name: "groomEmail",
      validation: emailError.value
    }, null, 8, ["modelValue", "is-valid", "label", "validation"]),
    _createVNode(_component_tw_input, {
      onInput: _cache[2] || (_cache[2] = () => emailError.value = ''),
      modelValue: brideEmail.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((brideEmail).value = $event)),
      "is-valid": !emailError.value?.length,
      label: _unref(t)('sidebar.brideEmail'),
      name: "brideEmail",
      validation: emailError.value
    }, null, 8, ["modelValue", "is-valid", "label", "validation"]),
    _createVNode(_component_v_sub_heading, { class: "-mb-4" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('confirmationChecklist.title')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", null, [
          _createVNode(_component_v_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('confirmationChecklist.completedSelection')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_v_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('confirmationChecklist.deadline')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_v_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('confirmationChecklist.customSong')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_v_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('confirmationChecklist.blankFields')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_v_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('confirmationChecklist.bgm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_v_checkbox_field, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_checkbox, {
            modelValue: submissionConfirmation.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((submissionConfirmation).value = $event)),
            class: "my-6",
            color: "teal",
            id: "submission-confirmation",
            name: "submission-confirmation"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_label, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('confirmationChecklist.confirmation')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (emailError.value?.length)
      ? (_openBlock(), _createBlock(_component_v_error_message, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(emailError.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (scriptError.value?.length)
      ? (_openBlock(), _createBlock(_component_v_error_message, { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scriptError.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_tw_button, {
        onClick: navigateNext,
        class: "btn-brand font-medium w-full mb-6",
        disabled: !submissionConfirmation.value,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('sidebar.submit')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"]),
      _createVNode(_component_tw_button, {
        onClick: _cache[5] || (_cache[5] = () => emit('navigateBack')),
        class: "font-medium w-full",
        "class-name": "text-blue-500",
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('sidebar.back')), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 64))
}
}

})